import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { CountryEntity } from "../../domain/models/country.model";

@Injectable({providedIn: 'root'})
export class GetCountriesUsecase implements UseCase<undefined, CountryEntity[]> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(): Observable<CountryEntity[]> {
    return this.locationRepository.getCountryData();
  }
}
